import {regReducer} from '../../core';
import * as a from './actions';
import * as s from './selectors';

regReducer(a.INIT, (state, {payload}) => {
    if (!s.tabs(payload).filter((tab) => tab.selected).length) {
        s.tabs(payload)[0].selected = true;
    }
    return s
        .selectedItems(payload)
        .reduce((state, item) => selectItem(state, item), payload);
});

regReducer(a.FINISH_CONFIGURATION, (state) => {
    let newState = Object.assign({}, state);
    const ids = s
        .selectedItems(state)
        .sort((itemA, itemB) => itemA.tab - itemB.tab)
        .reduce((ids, item) => {
            ids.push(item.appId);
            if (item.selectedPastryCrocoCode) {
                const pastry = s
                    .pastries(state)
                    .filter(
                        (pastry) =>
                            pastry.crocoCode === item.selectedPastryCrocoCode
                    )
                    .shift();
                ids.push(pastry.appId);
            }
            return ids;
        }, []);
    $.post({
        url: state.endpoint,
        data: JSON.stringify({items: ids}),
        dataType: 'json',
    }).then((response) => {
        window.location.href = response.location;
    });
    newState.finished = true;
    return newState;
});

regReducer(a.SELECT_TAB, (state, {payload}) => {
    let newState = Object.assign({}, state);
    newState.tabs = state.tabs.map((tab) => {
        tab.selected = payload.id === tab.id;
        return tab;
    });
    return newState;
});

regReducer(a.SELECT_ITEM, (state, {payload}) => {
    return selectItem(state, payload);
});

function selectItem(state, selectedItem) {
    let newState = Object.assign({}, state);
    const currentTab =
        newState.tabs.filter((tab) => tab.id === selectedItem.tab).pop() ||
        s.tabs(newState)[0];
    if (selectedItem.isPastry) {
        const previousTab = s.previousTab(newState, selectedItem.tab);
        const selectedItemFromPreviousTab = s.selectedItem(
            newState,
            previousTab.id
        );
        if (selectedItemFromPreviousTab) {
            newState.items = newState.items.map((item) => {
                if (
                    item.tab === previousTab.id &&
                    selectedItemFromPreviousTab.id === item.id
                ) {
                    item.selectedPastryCrocoCode = selectedItem.crocoCode;
                }
                return item;
            });
        }
    } else {
        newState.items = newState.items.map((item) => {
            if (item.tab === currentTab.id) {
                item.selected = selectedItem.id === item.id;
            }
            return item;
        });
    }
    const nextTab = newState.tabs
        .filter((tab) => {
            return (
                tab.order > currentTab.order &&
                ((selectedItem.pastries.length && tab.isPastry) ||
                    (!selectedItem.pastries.length && !tab.isPastry))
            );
        })
        .shift();

    if (nextTab) {
        newState.tabs = newState.tabs.map((tab) => {
            tab.selected = tab.id === nextTab.id;
            return tab;
        });
    }
    newState.menuDescription = s
        .visibleTabs(newState)
        .reduce((description, tab) => {
            const selectedItem = s.selectedItem(newState, tab.id);
            description =
                description +
                (selectedItem ? `${selectedItem.description}, ` : '');
            if (selectedItem && selectedItem.selectedPastryCrocoCode) {
                const pastry = s
                    .pastries(state)
                    .filter(
                        (pastry) =>
                            pastry.crocoCode ===
                            selectedItem.selectedPastryCrocoCode
                    )
                    .shift();
                description += `${pastry.description}, `;
            }
            return description;
        }, newState.staticTexts.menuDescriptionPrefix);

    return newState;
}
